import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const notifications = [{
  name: 'María G.',
  location: 'Ciudad de México',
  time: 'hace 2 minutos'
}, {
  name: 'James R.',
  location: 'Texas, USA',
  time: 'hace 5 minutos'
}, {
  name: 'Ana L.',
  location: 'Madrid, España',
  time: 'hace 8 minutos'
}, {
  name: 'Carlos M.',
  location: 'Bogotá, Colombia',
  time: 'hace 12 minutos'
}, {
  name: 'Sarah K.',
  location: 'California, USA',
  time: 'hace 15 minutos'
}, {
  name: 'Roberto P.',
  location: 'Buenos Aires, Argentina',
  time: 'hace 18 minutos'
}, {
  name: 'Emily W.',
  location: 'Florida, USA',
  time: 'hace 22 minutos'
}, {
  name: 'Laura S.',
  location: 'Lima, Perú',
  time: 'hace 25 minutos'
}, {
  name: 'David H.',
  location: 'New York, USA',
  time: 'hace 30 minutos'
}, {
  name: 'Patricia V.',
  location: 'Santiago, Chile',
  time: 'hace 35 minutos'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      if (!isDismissed) setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialDelay);
  }, [isDismissed]);
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    // Hide after 3 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 3000);
    // Show next notification after 3s hidden gap
    const nextTimer = setTimeout(() => {
      if (!isDismissed) {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setIsVisible(true);
      }
    }, 6000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [isVisible, currentIndex, isDismissed]);
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-163">
      {isVisible && !isDismissed && <motion.div initial={{
      opacity: 0,
      y: 20,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-[80] max-w-xs" data-id="element-164">
          <div className="bg-surface border border-white/10 rounded-xl p-4 shadow-2xl backdrop-blur-md flex items-start gap-3" data-id="element-165">
            <div className="flex-shrink-0 w-10 h-10 rounded-full overflow-hidden" data-id="element-166">
              <img src="https://cdn.magicpatterns.com/uploads/1tPzN97QYtGJHGfU8hLW4g/logo_checkout_2.png" alt="BioClock" className="w-full h-full object-cover" data-id="element-167" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-168">
              <p className="text-white text-sm font-semibold leading-tight" data-id="element-169">
                {current.name}
              </p>
              <p className="text-body text-xs mt-0.5" data-id="element-170">
                compró{' '}
                <span className="text-amber font-medium" data-id="element-171">
                  The BioClock Protocol
                </span>
              </p>
              <p className="text-muted text-xs mt-1" data-id="element-172">
                {current.location} · {current.time}
              </p>
            </div>
            <button onClick={() => setIsDismissed(true)} className="flex-shrink-0 text-muted hover:text-white transition-colors p-0.5" data-id="element-173">
              <X className="w-3.5 h-3.5" data-id="element-174" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}